import { moneyScaleForCurrency, type MoneyScale } from '@shared/money';
import { useBusinessProfileStore } from '../../shell/session/store/useBusinessProfileStore';

export function resolveOrgMoneyScale(currencyCode?: string | null): MoneyScale {
  return moneyScaleForCurrency(currencyCode ?? 'ARS');
}

export function getOrgMoneyScaleFromStore(): MoneyScale {
  const currency = useBusinessProfileStore.getState().profile?.country?.default_currency;
  return resolveOrgMoneyScale(currency);
}

export function useOrgMoneyScale(): MoneyScale {
  const currency = useBusinessProfileStore((s) => s.profile?.country?.default_currency);
  return resolveOrgMoneyScale(currency);
}
